import { defineStore } from "pinia";
import type Profile from "../models/profile";
import CommonUtils from "@/utils/common-util";

export interface optionsForm {
  value?: string;
  label?: string;
  color: string;
}

export const useMaterialsStore = defineStore("materials", {
  state: () => ({
    materialsKey: "" as string,
    // NOTE - 용도프로필 리스트
    profileList: [] as Array<Profile>,
    originProfileList: [] as Array<Profile>,
    selectProfileID: null as string | null,
    selectProfileInfo: {} as Profile,
    profileOption: [] as optionsForm[]
  }),
  getters: {
    getProfileList(state) {
      return state.profileList;
    },
    getProfileID(state) {
      return state.selectProfileID;
    },
    getSelectProfile(state) {
      return state.profileList.find((profile) => profile.usageProfileCode === state.selectProfileID) as Profile;
    },
    getProfileOptions(state){
      return state.profileOption;
    }
  },
  actions: {
    // NOTE - 모든 재료 정보 받기
    init(){
      this.getUsageProfileApi();
    },

    // NOTE - 용도프로필 데이터 받기
    async getUsageProfileApi(){
      const res = await this.apiServices.etcApiService.getUsageProfileCode();

      this.profileList = res as Profile[]; 
      this.originProfileList = CommonUtils.deepClone(res as Profile[]);

      // for(let i = 0; i < this.profileList.length; i++){
      //   this.profileList[i].displayLabel = this.profileList[i].usageProfileName;
      // }

      this.profileOption = this.makeProfileOptions();
    },

    getProfileData(profileID: string){
      for(let i = 0; i < this.profileList.length; i++){
        if(this.profileList[i].usageProfileCode === profileID){
          return this.profileList[i];
        }
      }

      return {} as Profile;
    },

    setSelectProfileData(profileID: string){
      for(let i = 0; i < this.profileList.length; i++){
        if(this.profileList[i].usageProfileCode === profileID){
          this.selectProfileID = profileID;
          this.selectProfileInfo = this.profileList[i];
        }
      }

      // return {} as Profile;
    },

    async addProfile(data: Profile) {
      const res = await this.apiServices.usageProfilesApiService.setUsageProfiles(data);
      console.log(res);
      return res;
    },
    async modifyProfile(data: Profile){
      const code = data.usageProfileCode as string;
      const res = await this.apiServices.usageProfilesApiService.patchUsageProfiles(data, code);
      console.log(res);
      return res;
    },

    setProfileID(profileId: string) {
      this.selectProfileID = profileId;
    },

    async removeProfile(usageProfileCode: string) {
      const res = await this.apiServices.usageProfilesApiService.removeUsageProfiles(usageProfileCode);

      return res;
      // const startIndex = this.profileList.findIndex((e) => e.usageProfileCode === profileId);
      // this.profileList.splice(startIndex, 1);
      // this.selectProfileID = null;
      // this.selectProfileInfo = {} as Profile;
      // console.log("삭제");
    },

    makeProfileOptions() {
      console.log("options make");
      const profileList = this.profileList;

      const options: Array<optionsForm> = [];

      profileList?.forEach((profile: Profile) => {
        options.push({
          value: profile.usageProfileCode,
          label: profile.usageProfileName,
          color: "dark"
        });
      });

      return options;
    },

    addProfileItem(profile: Profile) {
      this.profileList.push(profile);

      console.log("용도프로필 추가 버튼");
    },
  }
});
